import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";
import { adminArchivedToggleCommon } from "./exam-admin-common";
import { examAdminExamsDetail } from "./exam-admin-exams-detail";

export const examAdminExams = {
  ...adminArchivedToggleCommon,
  pageTitle: "Exam Center",
  pageSubtitle:
    "Manage official exam creation, assignment, publishing, status transitions, and score release.",
  createSuccess: "Exam created",
  archiveSuccess: "Exam archived",
  createAndStartSuccess: "Exam created and started immediately",
  createStartNowFailed: "Exam was created, but immediate start failed: {reason}",
  examRules: "Exam rules:",
  assignedCandidates: "Assigned candidates:",
  stats: {
    totalExamsLabel: "Total Exams",
    totalExams: "Total exams: {count}",
    summaryUnavailable: "Exam status counts failed to load; legend counts are unavailable",
    archivedExamsLabel: "Archived Exams",
    archivedExams: "Archived exams: {count}",
    totalCandidatesLabel: "Total Exam Participations",
    totalCandidates: "Total exam participations: {count}",
    totalDurationMinutesLabel: "Total Exam Duration",
    totalDurationMinutes: "Total exam duration: {count} minutes",
  },
  table: {
    code: "Exam Code",
    name: "Exam Name",
    searchPlaceholder: "Search by exam code or name",
    codeSearchPlaceholder: "Search by code",
    paperVersionSearchPlaceholder: "Search by paper name/code",
    status: commonShortNouns.status,
    paperVersion: "Paper Version",
    paperVersionMissing: "Paper version missing (ID #{id})",
    duration: "Duration",
    candidates: "Candidates",
    environmentLimits: "Container Limits",
    environmentLimitActive: "Concurrent {count}",
    environmentLimitTotal: "Total {count}",
    createdAt: commonShortFieldLabels.createdAt,
    actions: "Actions",
  },
  batch: {
    publish: "Batch Publish",
    start: "Batch Start",
    end: "Batch End",
    archive: "Batch Archive",
    publishScores: "Batch Publish Scores",
    selectFirst: "Please select exams first",
    actionSuccess: "Batch {action} completed for {count} exams",
    actionPartial: "Batch {action} completed for {success} exams; {failed} failed",
    publishScoresSuccess: "Scores published for {count} exams",
    publishScoresPartial: "Scores published for {success} exams; {failed} failed",
    confirm: {
      batchpublishScoresTitle: "Publish scores in batch?",
      batchpublishScoresDescription:
        "Scores will be published for the selected exams. Please confirm.",
      batcharchiveTitle: "Archive in batch?",
      batcharchiveDescription: "The selected exams will be archived. Please confirm.",
      batchendTitle: "End in batch?",
      batchendDescription: "The selected exams will be ended. Please confirm.",
      batchstartTitle: "Start in batch?",
      batchstartDescription: "The selected exams will be started. Please confirm.",
      batchpublishTitle: "Publish in batch?",
      batchpublishDescription: "The selected exams will be published. Please confirm.",
    },
  },
  newExamDrawerTitle: "Create Exam",
  codeRulePrefix:
    "The exam code is generated automatically after the first successful save, using the format",
  codeRulePattern: "E-YearWeek-Sequence",
  codeRuleSuffix: ", and cannot be changed after generation.",
  createWizard: {
    previous: "Previous",
    next: "Next",
    submit: "Create Exam",
    durationRequired: "Please enter exam duration",
    startNowDurationRequired: "Duration is required when starting immediately after creation",
    startMode: "Start Mode",
    startModeScheduled: "Scheduled Start",
    startModeImmediate: "Start Immediately After Creation",
    startModeImmediateHint:
      "The system will run Start Now automatically after creation; no manual click is needed.",
    endTimeAutoHint: "End time will be calculated automatically as: {value}",
    endTimeAutoHintEmpty:
      "Enter the start time and duration first; the system will calculate the end time automatically.",
    openExamHint:
      "This is an open exam. Any candidate can participate, so no candidates need to be assigned in this step.",
    recommendDuration: "Use paper recommended duration",
    recommendDurationUnavailable: "The current paper has no recommended duration configured",
    recommendDurationApplied: "Recommended duration applied: {minutes} minutes",
    openPaperPicker: "Open paper picker",
    paperPickerTitle: "Select Paper Version",
    paperPickerSearchPlaceholder: "Search by paper code or name",
    openCandidatePicker: "Lookup candidates",
    candidatePickerTitle: "Select Candidates",
    candidatePickerSearchPlaceholder: "Search by name or username",
    recommendName: "AI Recommended Name",
    recommendedNameTemplate: "{title} · Official Exam · {date}",
    recommendedNameApplied: "Recommended exam name applied",
    typePolicies: "Question Type Policies",
    paperOptionLabel: "{code} · {title} · V{versionNo} ({versionCode})",
    typePolicyShuffleQuestions: "Shuffle questions within type",
    typePolicyShuffleOptions: "Shuffle options",
    typePolicyAllowSelfCheck: "Allow candidate run",
    typePolicyMaxSelfCheckCount: "Max run count",
    typePolicyMaxSelfCheckCountPlaceholder: "Leave empty for unlimited",
    typePolicyAllowSelfCheckWithCount: "Allow candidate self-check ({count})",
    typePolicyGroupOrder: "Order Strategy",
    typePolicyGroupPractical: "Practical Strategy",
    typePolicyGroupAttackDefense: "Attack & Defense Strategy",
    typePolicyMaxCreateCount: "Max environment create count",
    typePolicyMaxCreateCountPlaceholder: "Leave empty for unlimited",
    typePolicyMaxCreateCountWithCount: "Max environment creates ({count})",
    typePolicyFlagResultMode: "Flag judging timing",
    typePolicyFlagResultModeImmediate: "Judge immediately and show result",
    typePolicyFlagResultModeDeferred: "Judge after submit",
    typePolicySummary: "Enabled: {summary}",
    typePolicySummaryNone: "None",
    customFieldsSectionTitle: "Custom Fields",
    selectPaperAction: "Select",
    steps: {
      basic: "Paper and Basic Info",
      rules: "Exam Rules",
      candidates: "Candidate Scope",
    },
  },
  status: "Exam Status",
  name: "Exam Name",
  nameRequired: "Please enter exam name",
  namePlaceholder: "Enter exam name",
  entryCode: "Entry code",
  entryCodeRequired: "Please enter entry code",
  entryCodePlaceholder: "Example: E-2613-003 or exam-security-001",
  entrySubdomain: "Entry subdomain prefix",
  entrySubdomainPlaceholder: "Example: e-2613-003 (visit e-2613-003.<root-domain>)",
  paperVersion: "Paper Version",
  paperVersionRequired: "Please select a paper version",
  paperVersionPlaceholder: "Select paper version",
  startTime: "Start Time",
  endTime: "End Time",
  durationMinutes: "Exam Duration (minutes)",
  publishScoreMode: "Score Publishing Mode",
  allowLateEntry: "Allow Late Entry",
  lateEntryGraceMinutes: "Max Late Entry Grace (minutes)",
  lateEntryGraceMinutesPlaceholder: "Leave empty for unlimited",
  earliestSubmitAt: "Earliest Submit Time",
  earliestSubmitAtPlaceholder: "Candidates cannot submit before this time",
  allowReentry: "Allow Re-entry",
  allowMultipleSubmit: "Allow Multiple Submissions",
  maxAttemptCount: "Max Attempts",
  maxAttemptCountRequired: "Please enter max attempts",
  maxAttemptCountPlaceholder: "Leave empty for unlimited",
  accessMode: "Participation Scope",
  accessModeAssigned: "Assigned Candidates",
  accessModeOpen: "Open Exam (any candidate)",
  resultVisibility: "Score Visibility",
  answerVisibility: "Answer Visibility",
  assignCandidates: "Assign Candidates",
  assignCandidatesPlaceholder: "Select candidates for this exam",
  advancedConfig: "Extended Config",
  advancedConfigHelp:
    "Common extended config is maintained by the form and generated automatically",
  advancedConfigRetainUnknown: "Unrecognized keys are retained during editing.",
  examNotice: "Exam Instructions",
  examNoticePlaceholder: "Pre-exam notices, environment notes, answer reminders, etc.",
  submitNotice: "Submission Notice",
  submitNoticePlaceholder: "Message shown to candidates when confirming submission",
  scoreNotice: "Score Release Notice",
  scoreNoticePlaceholder: "Example: scores will be released after manual review",
  proctoringNote: "Proctoring Note",
  proctoringNotePlaceholder:
    "Example: this exam requires camera monitoring throughout (reserved for V2)",
  environmentNote: "Environment Note",
  environmentNotePlaceholder: "Example: runtime notes for programming and practical questions",
  candidateEnvironmentMaxActive: "Max concurrent containers per candidate",
  candidateEnvironmentMaxActivePlaceholder: "Leave empty for unlimited",
  candidateEnvironmentMaxTotal: "Max container creations per candidate",
  candidateEnvironmentMaxTotalPlaceholder: "Leave empty for unlimited",
  enableAiReview: "Enable AI Initial Review",
  autoRecycleEnvironment: "Auto Recycle Environment",
  showQuestionNavigation: "Show Question Navigation",
  configJsonPreview: "config_json Preview",
  detail: examAdminExamsDetail,
};
